import { useEffect } from 'react';

/** Locks body scroll while an overlay is open, and restores it exactly once. */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;

    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [active]);
}
